import { SlidePreview } from '@/components/Deals/ProposalStudio/SlidePreview'
import type { PublicPresentationSlide } from '@/utils/publicProposalPresentationSlides'

const SLIDE_WIDTH = 880

type Props = {
  slide: PublicPresentationSlide
  index: number
}

/** Slide de valor fora da tela, no mesmo componente que o estúdio captura. */
export function PublicProposalPdfSlide({ slide, index }: Props) {
  return (
    <div
      aria-hidden
      data-public-pdf-slide={index}
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: SLIDE_WIDTH,
        transform: 'translateX(-120vw)',
        pointerEvents: 'none',
        zIndex: -1,
      }}
    >
      <SlidePreview
        layout={slide.layout}
        onLayoutChange={() => undefined}
        planName={slide.planName}
        planDescription={slide.planDescription}
        supportHoursLabel={slide.supportHoursLabel}
        supportTierLines={slide.supportTierLines}
        planTipo={slide.planTipo}
        projectType={slide.projectType}
        planValue={slide.planValue}
        isRecurring={slide.isRecurring}
        hidePricing={slide.hidePricing}
        priceCompareFrom={slide.priceCompareFrom}
        paymentDetails={slide.paymentDetails}
        loyaltyDuration={slide.loyaltyDuration}
        negotiationDeadlineLabel={slide.negotiationDeadlineLabel}
        bonusText={slide.bonusText}
        serviceGroups={slide.serviceGroups}
      />
    </div>
  )
}
